export { Anchor, DefaultAnchor } from './anchor';
export { DotType, Dot, CircleDot, DotFactory, RectDot } from './dot';
export { Canvas } from './Canvas';
export { Drawable } from './Drawable';
export { Polygon } from './Polygon';
export { Point, isPoint } from './Point';
export { formatll, llToStagell } from './coordinateNormalization';
